// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import FieldView from '../utils/FieldView';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const CustomerBox = ({ customer, party }) => {
  return (
    <div className='data-box'>
      <h4>
        <b>Customer</b>
      </h4>
      <FieldView name='Name'>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        {customer.memberName}
      </FieldView>
      <FieldView name='Email'>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        {customer.memberEmail}
      </FieldView>
      <FieldView name='Phone Number'>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        {customer.memberPhone}
      </FieldView>
      <FieldView name='Party Name'>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        <a className='app-link' href={`/party/${party.partyId}`}>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          {party.partyName}
        </a>
      </FieldView>
    </div>
  );
};

export default React.memo(CustomerBox);
